jQuery(document).ready(function($) {

	function setSideOffsetArrows() {
		var isMobile = ($(window).width()<650) ? true : false;
		var sideOffset = (isMobile) ? 40 : ($(window).width() - $('iframe.playing').first().width())/2 - 95;
		$('.prev-video').css('left', sideOffset);
		$('.next-video').css('right', sideOffset);
		$('.change-video').removeClass('not-visible');
	}

	var videoWindowTimeout = false;
	$(window).resize(function() {
		clearTimeout(videoWindowTimeout);
		videoWindowTimeout = setTimeout(function() {
			setSideOffsetArrows();
		}, 200);
	});

	function stopVideo() {
		var iframe = $(this).find('iframe.playing');
		if (iframe.length==1) {
			iframe.attr('src', '');
			iframe.removeClass('playing');
		}
	}

	function changeVideo(currVideoCol) {
		stopVideo();
		currVideoCol.closest('.reveal').find('.videos-wrapper > .row > .column').addClass('not-visible');
		currVideoCol.closest('.reveal').find('.active-video').removeClass('active-video');

		currVideoCol.removeClass('not-visible');
		currVideoCol.addClass('active-video');
		
		// Set source if needed
		var currVideo = currVideoCol.find('iframe');
		currVideo.addClass('playing');
		if (typeof currVideo.attr('src') === 'undefined' || currVideo.attr('src')==='') {
			currVideo.attr('src', currVideo.attr('data-src'));
		}
		if (currVideoCol.closest('.reveal').find('.change-video').first().hasClass('not-visible')) {
			$('.prev-video').css('left', '50%');
			$('.next-video').css('right', '50%');
			window.setTimeout(function(modal) {
				setSideOffsetArrows();
			}, 500, $(this));
		}
		customGtmVideoEvent('videoVisibleOnScreen', currVideoCol.find('h2').text());
	}

	var videoLastEventLabelSent = false;
	function customGtmVideoEvent(eventName, eventLabel) {
		if ((eventLabel + eventName)===videoLastEventLabelSent) return; // Prevent same label being sent twice in a row
		videoLastEventLabelSent = eventLabel + eventName;
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event':eventName,
			'eventLabel':eventLabel
		});
	}

	$(document)
	.on('click', '.button.video', function() {
		var videoId = $(this).attr('data-video-id');
		var videoModalId = $(this).attr('data-toggle');
		if ((typeof videoId === 'undefined') || (typeof videoModalId === 'undefined')) return;
		
		var modal = $('#' + videoModalId);
		var currVideoCol = modal.find('.video-' + videoId);
		changeVideo(currVideoCol);
		customGtmVideoEvent('videoButtonClicked', $(this).text());
	})
	.on('click', '.reveal .change-video', function(e) {
		e.preventDefault();
		var direction = $(this).attr('data-direction');
		var colIndex = $(this).closest('.reveal').find('.active-video').attr('data-' + direction + '-video-index');
		var targetCol = $(this).closest('.reveal').find('.column:nth-child(' + colIndex + ')');
		changeVideo(targetCol);		
	})
	.on('closed.zf.reveal', '.reveal', function() {
		stopVideo();
	});

});